<template>
    <div class="card-footer"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ name: 'CCardFooter' });
</script>
